/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapAreaMapSites', {
            bindings: {
                mode: '<',
                map: '<',
                model: '<',
                stateWithSites: '<',
                onStateDeselected: '&',
                onSiteSelected: '&',
                onSiteDeselected: '&'
            },
            controller: areaSitesController,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function areaSitesController($scope, leaflet, utilitiesService) {
        this.$onInit = onInit;
        this.$onChanges = onChanges;
        this.$onDestroy = onDestroy;

        var vm = this;
        var stateGroup;
        var siteMarkers = [];

        function onInit() {
            drawMarkers(vm.stateWithSites.Sites);
        }

        function onChanges(changes) {
            if (changes.model) {
                updateFeatureMarkers();
            }
        }

        function onDestroy() {
            stateGroup.clearLayers();
        }

        function updateFeatureMarkers() {
            angular.forEach(siteMarkers, function (marker) {
                drawMarkers(marker);
            });
        }

        function drawMarkers(sites) {
            angular.forEach(sites, function (site) {
                var isSelected = false;
                if (vm.mode.isEdit) {
                    isSelected = isSiteSelected(site.CustomerId);
                } else {
                    isSelected = true;
                }
                var displayName = site.CustomerName.split('-');
                var markerOptions = {
                    id: site.CustomerId,
                    name: displayName[0],
                    address: displayName[1],
                    city: displayName[2],
                    latitude: site.Latitude,
                    longitude: site.Longitude,
                    icon: markerTypes(isSelected),
                    draggable: false,
                    selected: isSelected
                };
                var customPopup = '<div class="leaflet-custom-popup"><label class="popup-title">' + displayName[0] +
                    '</label><label>' + displayName[1] + '</label><label>' + displayName[2] + '</label>' +
                    '<label>' + site.State.StateName + '</label></div>';

                var marker = leaflet.marker([site.Latitude, site.Longitude], markerOptions)
                    .bindPopup(customPopup, {closeButton: false})
                    .on('click', onClick)
                    .on('mouseover', showSiteInformation)
                    .on('mouseout', hideSiteInformation);
                siteMarkers.push(marker);
            });

            stateGroup = leaflet.layerGroup(siteMarkers);
            stateGroup.addTo(vm.map);
        }

        function showSiteInformation(e) {
            this.openPopup();
        }

        function hideSiteInformation(e) {
            this.closePopup();
        }

        function onClick(e) {
            this.closePopup();
            if (e.target.options.selected) {
                angular.forEach(vm.model.sites, function (site) {
                    if (site.id === e.target.options.id) {
                        var siteIndex = utilitiesService.getIndexOf(vm.model.sites, 'id', site.id);
                        vm.onSiteDeselected({ stateObject: { stateId: vm.model.id, siteIndex: siteIndex } });
                    }
                });
            } else {
                var site = {
                    id: e.target.options.id,
                    name: e.target.options.name,
                    address: e.target.options.address,
                    city: e.target.options.city,
                    latitude: e.target.options.latitude,
                    longitude: e.target.options.longitude
                };
                vm.onSiteSelected({ stateObject: { stateId: vm.model.id, site: site }});
            }

            e.target.options.selected = !e.target.options.selected;
            e.target.setIcon(markerTypes(e.target.options.selected));

            if (vm.model.sites.length === 0) {
                vm.onStateDeselected({ stateId: vm.model.id});
            }

            $scope.$apply();
        }
        
        function markerTypes(isActive) {
            var iconUrl;
            if (isActive) {
                iconUrl = 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FE7569';
            } else {
                iconUrl = 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|DDDDDD';
            }
            return leaflet.icon({
                iconUrl: iconUrl,
                iconSize: [21, 34],
                iconAnchor: [11, 33],
                popupAnchor: [-1, -30]
            });
        }

        function isSiteSelected(siteId) {
            return utilitiesService.getIndexOf(vm.model.sites, 'id', siteId) !== -1;
        }
    }
})();
